import { GroupMemberRole, useAppStore } from '@halo/chat-sdk-react';
import type { GroupedUsersList } from '@halo/ui-chat-react';
import { SearchField, GroupedUsers, UserSelectorDialog } from '@halo/ui-chat-react';

interface GroupRemoveMembersDialogProps {
  title: ReactNode;
  checkUserKey: boolean;
  list: GroupedUsersList[];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onOK: (selected: any[]) => Promise<any>;
  onClose?: () => void;
}

const GroupRemoveMembersDialog = ({
  title,
  checkUserKey,
  list,
  isOpen,
  setIsOpen,
  onOK,
}: GroupRemoveMembersDialogProps) => {
  const { user: currentUser } = useAppStore();
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState('');

  const listFormatted = useMemo(() => {
    return list.map(({ items, label }) => {
      const filteredItems = items?.filter((item) => {
        const isMe = item.user_id === currentUser?.user_id;
        const isOwner = item.role === GroupMemberRole.OWNER;
        if (isMe || isOwner) {
          item.disabled = true;
        }
        return item?.name?.toLowerCase().includes(searchValue?.toLowerCase());
      });
      return { label, items: filteredItems };
    });
  }, [list, currentUser?.user_id, searchValue]);

  const {
    // listFlat,
    selected,
    // canSelectList,
    // isSelectedAll,
    toggleSelectUser,
    // onSelectAllChange,
    onRemove,
    resetDialogState,
  } = UserSelectorDialog.useUserSelector(listFormatted, checkUserKey);

  useLayoutEffect(() => {
    if (!isOpen) {
      resetDialogState();
      setSearchValue('');
    }
  }, [isOpen, resetDialogState]);

  return (
    <UserSelectorDialog.Root isOpen={isOpen} setIsOpen={setIsOpen}>
      <UserSelectorDialog.Header title={title} />
      <UserSelectorDialog.Body
        selectedList={
          <UserSelectorDialog.SelectedList
            selected={selected}
            onRemove={onRemove}
            checkUserKey={checkUserKey}
          />
        }
      >
        <SearchField searchValue={searchValue} onChange={setSearchValue} />
        <GroupedUsers
          list={listFormatted}
          toggleSelectUser={toggleSelectUser}
          selected={selected}
          checkUserKey={checkUserKey}
        />
        {/* {listFlat.length > 0 && canSelectList.length > 0 && (
          <UserSelectorDialog.SelectAll isChecked={isSelectedAll} onChange={onSelectAllChange} />
        )} */}
      </UserSelectorDialog.Body>
      <UserSelectorDialog.Footer
        selected={selected}
        onOK={onOK}
        cancelText={t('buttons.cancel')}
        okText={t('buttons.remove')}
        okConfirm={true}
        confirmText={
          selected.length > 1 ? t('chat.removeMembersConfirm') : t('chat.removeMemberConfirm')
        }
      />
    </UserSelectorDialog.Root>
  );
};

const MemoizedGroupRemoveMembersDialog = memo(GroupRemoveMembersDialog);

export { MemoizedGroupRemoveMembersDialog as GroupRemoveMembersDialog };
